import { Component, Inject, OnInit } from "@angular/core";
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from "@angular/material/bottom-sheet";

@Component({
  selector: "lib-update-notification",
  templateUrl: "./update-notification.component.html",
  styleUrls: ["./notification.component.scss"],
})
export class UpdateNotificationComponent implements OnInit {
  versionString = "";

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { version: string },
    private bottomSheetRef: MatBottomSheetRef<UpdateNotificationComponent>
  ) {
    this.versionString = this.data.version;
  }

  ngOnInit(): void {
    this.bottomSheetRef.afterDismissed().subscribe(() => {
      // Reloading mid swipe-to-dismiss could capture the page while it was
      // rubber-banded, leaving the reloaded app shifted down on iOS - settle
      // the document at the top first.
      window.scrollTo(0, 0);
      setTimeout(() => window.location.reload(), 300);
    });
  }

  public close() {
    this.bottomSheetRef.dismiss();
  }
}
